<template>
  <div class="wrapper">
    <van-nav-bar left-arrow title="订单详情" fixed @click-left="onClickLeft" />
    <div class="pad">&emsp;</div>
    <!-- 已取消 -->
    <div v-if="[5].includes(detailObject.status)" class="head-status">
      <van-image
        style="vertical-align: bottom"
        width="5%"
        :src="require('@/assets/images/tanhao.png')"
      />
      <span class="show-status">已取消</span>
      <div class="cancel-remark">取消原因:{{ detailObject.remark }}</div>
    </div>
    <!-- 已完成 -->
    <div v-if="[4].includes(detailObject.status)" class="head-status">
      <van-image
        style="vertical-align: bottom"
        width="5%"
        :src="require('@/assets/images/redhook.png')"
      />
      <span class="show-status show-finish">订单已完成</span>
    </div>
    <!-- 地址 -->
    <address-detail
      v-if="![0].includes(detailObject.status)"
      :detailObjects="detailObject.shippingAddressVo"
    ></address-detail>
    <div
      v-for="(item, index) in detailObject.orderProductGroupVos"
      :key="index"
    >
      <div class="storetop commondiv">
        <div class="storetxt">
          <img
            class="storetxt-img"
            style="vertical-align: bottom"
            :src="require('@/assets/images/storeIcon.png')"
          />
          <span class="storetxt-nameInMall">{{ detailObject.nameInMall }}</span>
        </div>
        <div class="storetxt redcolor">&nbsp;</div>
      </div>

      <div
        class="productslist commondiv"
        v-for="(obj, ind) in item.products"
        :key="ind"
      >
        <van-row @click="toProduct(obj)" gutter="15">
          <van-col>
            <img class="head-img" :src="obj.productPictureUrl" />
          </van-col>
          <van-col span="16">
            <div>
              <p class="product-title">{{ obj.title }}</p>
            </div>
            <div class="product-ground">
              <span class="product-price">￥{{ obj.productPrice }}</span>
              <span class="product-number">数量:{{ obj.productQuantity }}</span>
            </div>
          </van-col>
        </van-row>
      </div>
      <!-- 修改发货地址 -->
      <div
        v-if="[0].includes(detailObject.status)"
        class="infoshow infoshow-common"
      >
        <p>服务方式:{{ detailObject.deliveryMethod | distributionMode }}</p>
        <p>收货人:{{ detailObject.shippingAddressVo.contacts }}</p>
        <p>联系电话:{{ detailObject.shippingAddressVo.phoneNumber }}</p>
        <van-row class="infoshow-row">
          <van-col>收货地址:</van-col>
          <van-col span="19"
            >{{ detailObject.shippingAddressVo.address
            }}{{ detailObject.shippingAddressVo.detailsAddress }}</van-col
          >
        </van-row>
        <div style="color: #0c6cff" class="infoshow-row" @click="modify">
          修改
        </div>
      </div>
      <!-- 修改地址弹窗 -->
      <van-dialog
        class="modify-dialog"
        v-model="modifyShow"
        @confirm="modifyConfirm"
        show-cancel-button
      >
        <p>原先详细地址:{{ detailObject.shippingAddressVo.detailsAddress }}</p>
        <van-cell-group>
          <van-field
            v-model="modifyTxt"
            :clearable="true"
            placeholder="请输入详细地址"
          />
        </van-cell-group>
      </van-dialog>

      <div
        class="infoshow infoshow-common"
        v-if="[2, 3, 4].includes(detailObject.status)"
      >
        <div class="storetop">
          提货券
          <van-image
            width="80"
            height="80"
            class="usedicon"
            :src="require('@/assets/images/themepage/used.png')"
            v-if="detailObject.pickupCodeStatus === 1"
          />
        </div>

        <van-row gutter="15" class="qr-content">
          <van-col>
            <div id="qr" ref="qrcode"></div>
          </van-col>
          <van-col class="input-qr">
            <div
              style="text-align: right"
              v-if="[2].includes(detailObject.status)"
            >
              <van-field
                v-model="verifyCode"
                placeholder="请输入核销码"
              ></van-field>
              <div>&emsp;</div>
              <van-button
                class="submittxt"
                round
                @click="onClickSubmit(detailObject)"
                >&emsp;核销&emsp;</van-button
              >
            </div>
            <div class="qrdiv" v-if="detailObject.pickupCodeStatus === 1">
              <div class="usedtxt">已使用</div>
            </div>
          </van-col>
        </van-row>

        <!-- <div class="qrdiv">
          <div id="qr" ref="qrcode"></div>
          <div style="text-align:right;" v-if="[2].includes(detailObject.status)">
            <van-field v-model="verifyCode" placeholder="请输入核销码"></van-field>
            <div>&emsp;</div>
            <van-button
              class="submittxt"
              size="small"
              round
              @click="onClickSubmit(detailObject)"
            >&emsp;核销&emsp;</van-button>
          </div>
          <div class="qrdiv" v-if="detailObject.pickupCodeStatus===1">
            <div class="usedtxt">已使用</div>
          </div>
        </div>-->
        <div v-if="detailObject.expireTime" class="qr-time">
          {{ detailObject.expireTime }}到期
        </div>
        <!-- <van-divider /> -->
        <p class="pickupcode">提货码：{{ detailObject.pickupCode }}</p>
      </div>
      <div class="infoshow infoshow-common">
        <van-row class="infoshow-row" type="flex" justify="space-between">
          <van-col>商品总价</van-col>
          <van-col class="infoshow-col"
            >{{ detailObject.totalAmount }}元</van-col
          >
        </van-row>
        <van-row class="infoshow-row" type="flex" justify="space-between">
          <van-col>运费(配送费)</van-col>
          <van-col class="infoshow-col"
            >{{ detailObject.freightAmount }}元</van-col
          >
        </van-row>
        <van-row class="infoshow-row" type="flex" justify="space-between">
          <van-col>应付金额</van-col>
          <van-col class="infoshow-col">{{ detailObject.payAmount }}元</van-col>
        </van-row>
        <van-row class="infoshow-row" type="flex" justify="space-between">
          <van-col class="show-red">实付金额</van-col>
          <van-col class="infoshow-col show-red"
            >{{ detailObject.payAmount - detailObject.reduction }}元</van-col
          >
        </van-row>
      </div>
      <div class="infoshow infoshow-common">
        <p>订单号码:&ensp;{{ detailObject.orderSn }}</p>
        <p>下单时间:&ensp;{{ detailObject.createTime }}</p>
        <p v-if="[2, 3, 4].includes(detailObject.status)">
          支付方式:&ensp;{{ detailObject.payType | showType }}
        </p>
        <p v-if="![0, 5].includes(detailObject.status)">
          支付时间:&ensp;{{ detailObject.paymentTime }}
        </p>
        <p>配送方式:{{ detailObject.deliveryMethod | distributionMode }}</p>

        <!-- <p>配送地址:&ensp;{{detailObject.shippingAddressVo.address}}{{detailObject.shippingAddressVo.detailsAddress}}</p> -->
      </div>
      <div class="paybtn" v-if="detailObject.status === 0">
        <div class="btn_again" @click="onClickPay(detailObject)">立即支付</div>
      </div>
      <div class="paybtn">
        <van-button
          class="paybutton"
          size="small"
          round
          @click="onClickContact(detailObject)"
          v-if="[2, 3].includes(detailObject.status)"
          >联系卖家</van-button
        >
        <van-button
          size="small"
          class="paybutton"
          round
          @click="onClickDelete(detailObject)"
          v-if="[4, 5, 12].includes(detailObject.status)"
          >删除订单</van-button
        >
      </div>
    </div>
    <toast-show :showMessage="showMessage" :showToast="showToast" />
    <div class="phone_popup">
      <van-popup v-model="showPopu">
        <van-divider class="phone_title" :style="{ borderColor: '#C9CACA' }"
          >电话</van-divider
        >
        <div
          class="phone_mes"
          v-for="(item, index) in basicTelephone"
          :key="index"
        >
          <van-cell-group>
            <van-cell @click="callPhone(item)" title="服务热线" :value="item" />
          </van-cell-group>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { getFpOrderDetail, pickupCode } from '@/api/themedata.js'
import toastShow from '@/components/content/toastShow'
import addressDetail from '@/components/content/addressDetail'
import { Dialog } from 'vant'
import QRCode from 'qrcodejs2'
import { toPay, deleteOrder } from '@/api/productsDetaile'
import increaseFpClickCountMixin from '@/mixins/increaseFpClickCountMixin'
import anotherOne from '@/mixins/anotherOne'
import getIsWx from '@/mixins/getIsWx'
import Cookies from 'js-cookie'

import { FRONTEND_HOST } from '@/config/domainnameconstant'

export default {
  name: 'Intracittyservicepage',
  mixins: [increaseFpClickCountMixin, anotherOne, getIsWx],
  components: {
    toastShow,
    QRCode,
    addressDetail,
  },
  filters: {
    // 配送方式
    distributionMode(val) {
      let text = ''
      switch (Number(val)) {
        case 1:
          text = '快递'
          break
        case 2:
          text = '同城配送'
          break
      }
      return text
    },
    getCountOfProducts(arr) {
      // 计算有多少个商品
      let count = 0
      arr.forEach((element) => {
        element.products.forEach((ele) => {
          count = count + ele.productQuantity
        })
      })
      return count
    },
    showType(key) {
      let txt = ''
      // 支付方式,可用值:0 (未支付) ,1 (微信 App 支付) ,2 (微信 JSAPI 支付) ,3 (微信 Native 支付) ,4 (微信付款码支付) ,5 (微信 H5 支付) ,6 (微信小程序支付) ,7 (工行微信 JSAPI 支付) ,8 (工行微信小程序支付) ,9 (工行支付宝支付) ,10 (工行PC支付) ,11 (工行App支付)
      switch (Number(key)) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          txt = '微信'
          break
        case 7:
        case 8:
        case 10:
        case 11:
          txt = '工行'
          break
        case 9:
          txt = '支付宝'
          break
        default:
          txt = '未知'
          break
      }
      return txt
    },
  },
  data() {
    return {
      basicTelephone: [],
      showPopu: false,
      modifyTxt: '',
      modifyShow: false,
      detailObject: {},
      text: '',
      id: null,
      showMessage: '',
      showToast: false,
      verifyCode: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.init()
    window.document.title = '订单详情'
  },
  mounted() {},
  methods: {
    toProduct(obj) {
      if (this.identity) {
        this.$router.push({
          path: `/mall/detail`,
          query: {
            id: obj.productId,
            storeId: this.detailObject.storeId,
          },
        })
      } else {
        this.$router.push({
          path: `/mall/detail`,
          query: {
            id: obj.productId,
            storeId: this.detailObject.storeId,
          },
        })
      }
    },
    init() {
      getFpOrderDetail(this.id).then((res) => {
        if (res.data.code === 200) {
          this.detailObject = res.data.data
          console.log(this.detailObject)
          this.$nextTick(() => {
            if (
              this.detailObject.deliveryMethod === 2 &&
              !this.$isEmpty(this.detailObject.pickupCode)
            ) {
              this.createQr()
            }
          })
        }
      })
    },
    onClickContact(item) {
      this.basicTelephone = item.telephone.split(',')
      if (this.basicTelephone.length > 1) {
        this.showPopu = true
      } else {
        window.location.href = 'tel:' + item.telephone
      }
    },
    // 删除订单
    onClickDelete(item) {
      console.log('删除订单', item)
      Dialog.confirm({
        title: '提示',
        message: '确定删除订单吗?',
        className: 'confirmwindow',
      })
        .then(() => {
          deleteOrder(item.orderId)
            .then((res) => {
              if (res.data.code === 200) {
                this.ShowToast('删除订单成功')
                this.init()
              } else {
                this.ShowToast(res.data.msg)
              }
            })
            .catch((err) => {
              this.ShowToast(err.message)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 修改确认
    modifyConfirm() {
      this.modifyShow = true
      if (this.modifyTxt) {
        this.detailObject.shippingAddressVo.detailsAddress = this.modifyTxt
        const query = {
          detailsAddress: this.detailObject.shippingAddressVo.detailsAddress,
          orderId: this.detailObject.orderId,
        }
        this.hasModifyDetailAddress(query)
      }
      this.modifyTxt = ''
    },
    // 修改地址
    modify() {
      this.modifyShow = true
    },
    // hasPickupCode(obj){//查看是不是有提货码,再决定显示二维码
    //   if (!obj) {
    //     return false;
    //   }
    //  return obj.every((ele)=>{
    //     return ele.pickupCode?true:false
    //   })
    // },
    showBuinessTime(timestr) {
      // "周六,周日#24小时营业;周四,周五#00:01,00:28;周六#24小时营业" 这是时间的demo
      let txt = ''
      timestr.split(';').forEach((value) => {
        value.split('#').forEach((ele) => {
          if (ele.includes(':')) {
            txt += ele.replace(',', '-') // 如果是逗号,那就是时间段,替换成-号
          } else {
            txt += ele
          }
          txt += ' '
        })
        txt += '<br>'
      })
      return txt
    },
    ShowToast(message) {
      this.showMessage = message
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, 1500)
    },
    onClickSubmit(object) {
      console.log('pickupCode:', object.pickupCode)
      if (!this.verifyCode) {
        this.ShowToast('请输入核销码')
        return
      }
      pickupCode({
        code: object.pickupCode,
        merchant: false,
        verificationCode: this.verifyCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.ShowToast('核销成功')
          this.clearQr()
          this.init()
        } else {
          this.ShowToast(res.data.msg)
        }
      })
    },
    clearQr() {
      // 依次删除qr
      //   let array = this.detailObject.orderProductGroupVos
      //   for (let i = 0; i < array.length; i++) {
      //      // 一定要加上document.getElementById("qrcode").innerHTML = "";，否则每执行一次就会多一个二维码
      //      document.getElementById('qr'+i).innerHTML = "";
      //   }
      document.getElementById('qr').innerHTML = ''
    },
    createQr() {
      this.qrcodeNumber(0, this.detailObject.pickupCode)
      //   //依次生成qr
      //   let array = this.detailObject.orderProductGroupVos
      //   for (let index = 0; index < array.length; index++) {
      //     const element = array[index];
      //     this.qrcodeNumber(index, element.pickupCode)
      //   }
    },
    qrcodeNumber(i, qrdata) {
      const qrcode = new QRCode('qr', {
        width: 80, // 设置宽度
        height: 80, // 设置高度
        text: qrdata,
      })
    },
    onClickPay(data) {
      const toPayRequestVo = {
        orderId: data.orderId,
        payEnv: 1,
      }
      this.immediatelyPay(toPayRequestVo)
    },
    // 立即支付
    immediatelyPay(query) {
      this.submmitLoading = true
      //去支付接口
      toPay(query)
        .then((res) => {
          if (res.data.code === 200) {
            this.submmitLoading = false
            let payData = {
              payData: res.data.data.payData,
              orderId: res.data.data.orderId,
              certificationType: res.data.data.certificationType,
              payType: res.data.data.payType,
            }
            let successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
            let failReturnUrl = `${FRONTEND_HOST}/themepage/error?id=${payData.orderId}`
            window.location.href =
              payData.payData +
              `&successReturnUrl=${encodeURIComponent(
                successReturnUrl
              )}&failReturnUrl=${encodeURIComponent(failReturnUrl)}`
          }
        })
        .catch((error) => {
          this.submmitLoading = false
          this.showMessage = error.msg
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 3000)
        })
    },
    // 电话
    callPhone(phoneNumber) {
      window.location.href = 'tel:' + phoneNumber
    },
    onClickLeft() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.push({
          path: '/mall/order',
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
* {
  margin: 0px;
  padding: 0px;
}
.wrapper {
  background-color: #efefef;
}
.head-status {
  margin: 30px 0;
  text-align: center;
  .show-status {
    font-size: 16px;
    padding-left: 4px;
    color: #666;
  }
  .show-finish {
    color: #f44d4d;
  }
  .cancel-remark {
    padding-top: 6.5px;
    font-size: 12px;
    color: #adadad;
  }
}
* {
  font-size: 14px;
}
//电话弹出框
.phone_popup {
  .phone_title {
    color: #595757;
    padding: 0 8px;
    font-size: 15px;
    text-align: center;
    margin: 15px 0 15px 0;
  }
  .van-popup--center {
    width: 275px;
    height: 241.5px;
  }
  .van-cell {
    color: #3e3a39;
    line-height: 16.5px;
    font-size: 15px;
    padding: 7.5px 12.5px;
  }
}
.van-nav-bar__title {
  font-size: 18px;
}

.van-nav-bar {
  height: 44px;
  line-height: 44px;
}

.van-nav-bar--fixed {
  height: 44px;
}

/deep/.van-icon {
  color: black;
  font-size: 16px;
}
/deep/.van-nav-bar__text {
  font-size: 16px;
  color: black;
}

.pad {
  height: 44px;
}

.noorder {
  text-align: center;
  margin: 50px auto;
}

.storediv {
  margin: 2.5px 0px;
  border-radius: 5px;
  background-color: #fff;
  padding: 0px 20px;
}
.commondiv {
  background-color: #fff;
  padding: 0px 20px;
}
.infoshow-common {
  margin: 10px 0 0;
}

.flextimeshow {
  display: flex;
  justify-content: flex-start;

  .storetime {
    white-space: nowrap;
  }
}

.infoshow {
  margin: 10px 0px;
  padding: 5px 20px;
  background-color: #fff;
  font-size: 12px;
  p {
    color: #666;
    padding: 5px 0px;
    letter-spacing: 1px;
  }
  .infoshow-row {
    padding: 5px 0px;
    letter-spacing: 1px;
    color: #666;
    .infoshow-col {
      text-align: right;
    }
    .show-red {
      color: #f44d4d;
    }
  }
}

.productslist {
  padding: 5px 17px;
  position: relative;
}

.listcell {
  line-height: 20px;
}

.flexbtn {
  display: flex;
  justify-content: flex-end;
}

/deep/.flexbtn .van-button {
  margin-right: 5px;
}

.ordebottom {
  text-align: right;
  padding: 5px;
}

//vant-load加载
/deep/ .vant-load {
  .van-loading__text {
    color: #1989fa;
  }

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11111;
}

.storetop {
  display: flex;
  justify-content: space-between;
  // padding: 0 40px;
  margin-top: 10px;
  position: relative;
  .storetxt {
    font-size: 15px;
    padding: 5px;
    .storetxt-nameInMall {
      padding-left: 5px;
    }
    .storetxt-img {
      width: 20px;
      height: 18px;
    }
  }
  .usedicon {
    position: absolute;
    top: 30px;
    left: 20px;
    // top: 355px;
    // left: 20px;
  }
}

.qrdiv {
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  /*实现垂直居中*/
  justify-content: space-around;
  /*实现水平居中*/
  // justify-content: center;
  margin-top: 10px;

  .usedtxt {
    color: red;
    font-size: 15px;
    align-self: flex-end;
    position: relative;
    // bottom: 20px;
    right: -40px;
  }
}
.qr-content {
  padding-bottom: 5px;
  .input-qr {
    .van-button {
      height: 25px;
    }
  }
}
.qr-time {
  padding: 5px 0 0px;
  color: #666;
}
/deep/.van-cell:not(:last-child)::after {
  display: none;
}

.redcolor {
  color: red;
}

/deep/.image-text-list .img {
  border-radius: 10px;
}

/deep/.van-field__control {
  border: 1px solid #eee;
}

.btn_again {
  background-color: #f56c6c;
  color: #fff;
  width: 275px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  border-radius: 25px;
  margin-bottom: 15px;
}

.paybtn {
  display: flex;
  justify-content: center;
  margin: 10px 0px;
}
.paybutton {
  background-color: #efefef;
  border: 1px solid #727171;
  color: #666;
}
.confirmget {
  background: linear-gradient(
    90deg,
    rgba(205, 4, 50, 1) 0%,
    rgba(242, 93, 1, 1) 100%
  );
  color: white;
  text-align: center;
}
// /deep/ .van-field__control {
//   padding: 4px;
// }

// .submittxt > .van-button__text {
//   font-size: 5vw;
// }
//修改弹窗地址
.modify-dialog {
  font-size: 14px;
  p {
    color: black;
    padding: 15px 0px;
    text-align: center;
  }
  /deep/ .van-cell__value {
    display: block;
  }
  /deep/ .van-field__control {
    border: none;
    text-align: center;
  }
  .buyagainItems-row {
    margin-bottom: 6px;
    .buyagainItems-img {
      width: 45px;
      height: 45px;
    }
    .buyagainItems-title {
      padding-bottom: 6px;
    }
  }
}
.head-img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.product-title {
  margin: 5px 0px 0px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.product-ground {
  padding: 8px 0px;
  .product-price {
    font-size: 18px;
  }
  .product-number {
    padding-left: 10px;
    font-size: 13px;
    color: #666;
  }
}
.van-row {
  margin: 0 !important;
}
</style>
